import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import _ from 'lodash';
import PropTypes from 'prop-types';
import CardHeader from "../../card-header/CardHeader";
import {I18nUtils} from "../../../../../i18n/I18nUtils";
import HeaderSearchRefreshFilterOptions from "../../HeaderSearchRefreshFilterOptions";
import Paginator from "../../Paginator";
import CardBody from "../../CardBody";
import * as machineActions from '../../../../machines/actions/machineActions';
import StateManager from "../../../utils/StateManager";
import Tab from "../../Tab";
import MachinesTabTable from "./MachinesTabTable";

class MachinesTab extends React.Component {

  constructor(props) {
    super(props);

    this.onRefresh = this.onRefresh.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onPage = this.onPage.bind(this);

    this.state = StateManager.getState(this.props.id);
  }


  componentWillMount() {
    this.props.machineActions.getMachinesStates();
    this.getMachines();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.search !== this.state.search
      || prevState.filter !== this.state.filter
      || prevState.page !== this.state.page) {
      this.getMachines();
    }
    StateManager.saveState(this.props.id, this.state);
  }

  getMachines() {
    if (!this.props.showDeleted) {
      this.props.machineActions.getMachines(this.state.page, this.state.search, this.state.filter, this.props.companyId, false, true);
    } else {
      this.props.machineActions.getMachinesDeleted(this.state.page, this.state.search, this.state.filter, this.props.companyId);
    }
  }

  onRefresh() {
    this.getMachines()
  }

  onSearch(search) {
    this.setState({search: search, page: 1});
  }

  onPage(page) {
    this.setState({page})
  }

  renderFilterName() {
    const states = _.keyBy(this.props.machinesStates, 'id');
    if (states && states[this.state.filter]) {
      return states[this.state.filter].name;
    }
    return '';
  }

  renderHeaderOptions() {

    const filterOptions = this.props.machinesStates.map((machineState) => {
      return {
        title: machineState.name,
        active: machineState.id === this.state.filter,
        onClick: () => {
          this.setState({filter: machineState.id, page: 1});
        },
      }
    });

    return (
      <HeaderSearchRefreshFilterOptions
        onRefresh={this.onRefresh}
        onSearch={this.onSearch}
        searchText={this.state.search}
        filterOptions={filterOptions}
      />
    );
  }


  render() {
    return (
      <Tab loading={this.props.machinesLoading}>
        <CardHeader
          title={this.props.title.toUpperCase()}
          subtitle={this.renderFilterName()}
          rightOptions={this.renderHeaderOptions()}
        />
        <CardBody>
          <MachinesTabTable
            data={this.props.machines}
            error={this.props.machinesError}
            selectedIds={this.props.selectedIds}
            actionSelectItem={this.props.actionSelectItem}
            actionSelectAll={this.props.actionSelectAll}
            selectText={this.props.selectText}
            selectAllText={this.props.selectAllText}
            action={this.props.action}
            actionText={this.props.actionText}
            showOutsource={this.props.showOutsource}
          />
          <Paginator
            data={this.props.machinesPagination}
            onPage={this.onPage}
          />
        </CardBody>
      </Tab>
    );
  }

}

const mapStateToProps = state => {

  let errorMessage = state.machines.machinesError;
  if (!errorMessage && Object.keys(state.machines.machines).length === 0 && !state.machines.machinesLoading) {
    errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
  }
  return ({
    machines: state.machines.machines,
    machinesPagination: state.machines.machinesPagination,
    machinesLoading: state.machines.machinesLoading,
    machinesError: errorMessage,
    machinesStates: state.machines.machinesStates,
  });
};

const mapDispatchToProps = dispatch => ({
  machineActions: bindActionCreators(machineActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MachinesTab);

MachinesTab.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  companyId: PropTypes.string,
  showOutsource: PropTypes.bool,

  selectedIds: PropTypes.array,
  actionSelectItem: PropTypes.func,
  actionSelectAll: PropTypes.func,
  selectText: PropTypes.string,
  selectAllText: PropTypes.string,
  action: PropTypes.any,
  actionText: PropTypes.string,
  showDeleted: PropTypes.bool,
};

MachinesTab.defaultProps = {
  companyId: null,
  showOutsource: false,
  title: I18nUtils.tr('TR_MAQUINARIA'),
  showDeleted: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/machines/MachinesTab.js